import React from "react"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { LazyLoadImage } from "react-lazy-load-image-component"
import IconButton from "../../map/components/icon-button"
import ArrowLeft from "../../assets/icons/left.svg"
import ArrowRight from "../../assets/icons/right.svg"
import "./carousel-styles.css"

const CustomCarousel = ({ images = [], selectedTab }) => {
  const renderImages = () => {
    return images.map((image, index) => {
      return (
        <div key={index} className="h-52 sm:h-60 flex justify-center">
          <LazyLoadImage
            placeholder={
              <div className="!w-full h-full flex items-center justify-center">
                Loading..
              </div>
            }
            src={image}
            alt=""
            className="!w-full rounded-t-lg block object-cover object-center"
          />
        </div>
      )
    })
  }

  return (
    <Carousel
      key={selectedTab}
      showThumbs={false}
      showStatus={false}
      selectedItem={0}
      infiniteLoop
      className="w-full"
      renderArrowPrev={(onClickHandler, _hasPrev, label) => {
        if (images.length > 1) {
          return (
            <IconButton
              icon={ArrowLeft}
              className="bg-white absolute top-24 -left-4 sm:-left-6 z-10"
              onClick={(event) => {
                event.stopPropagation()
                onClickHandler()
              }}
              title={label}
              imgClassName="!w-6 !h-6"
            />
          )
        }
      }}
      renderArrowNext={(onClickHandler, _hasNext, label) => {
        if (images.length > 1) {
          return (
            <IconButton
              icon={ArrowRight}
              className="bg-white absolute top-24 -right-4 sm:-right-6 z-10"
              onClick={(event) => {
                event.stopPropagation()
                onClickHandler()
              }}
              title={label}
              imgClassName="!w-6 !h-6"
            />
          )
        }
      }}
      renderIndicator={(onClickHandler, isSelected, index, label) => {
        if (isSelected) {
          return (
            <li
              className="inline-block mx-0.5 bg-gray-600 border border-white w-4 h-4 rounded-full"
              aria-label={`Selected: ${label} ${index + 1}`}
              title={`Selected: ${label} ${index + 1}`}
            />
          )
        }
        return (
          <li
            className="inline-block mx-0.5 bg-gray-100 border border-white w-4 h-4 rounded-full"
            onClick={(event) => {
              event.stopPropagation()
              onClickHandler()
            }}
            onKeyDown={(event) => {
              event.stopPropagation()
              onClickHandler()
            }}
            value={index}
            key={index}
            role="button"
            tabIndex={0}
            title={`${label} ${index + 1}`}
            aria-label={`${label} ${index + 1}`}
          />
        )
      }}>
      {renderImages()}
    </Carousel>
  )
}

export default CustomCarousel
